import { CircularProgress } from '@material-ui/core';

/**
 * Standard validation regex helpers shared by Nobl9 field extensions.
 */
export const nobl9Patterns = {
  slug: /^[a-z0-9]+[a-z0-9-]*[a-z0-9]+$/,
  dataSource: /^[A-Za-z0-9_.-]+$/,
};

export interface HelperTextOptions {
  loading: boolean;
  error?: string;
  hasItems: boolean;
  required?: boolean;
  stale?: boolean; // indicates cached data being shown after failed refresh
  singularLabel: string; // e.g. 'project', 'service', 'data source'
}

/**
 * Builds a consistent helper text based on common metadata loading states.
 */
export function buildHelperText(opts: HelperTextOptions): string {
  const { loading, error, hasItems, required, stale, singularLabel } = opts;
  if (loading) return `Loading Nobl9 ${singularLabel}s…`;
  if (error) {
    return `${error}${hasItems ? ' (showing cached)' : ''}`;
  }
  if (!hasItems) return `No ${singularLabel}s found`;
  const base = required ? `Select a Nobl9 ${singularLabel}` : 'Optional';
  return stale ? `${base} (cached)` : base;
}

/**
 * Shared adornment for MUI Autocomplete input showing loading spinner.
 */
export function renderLoadingAdornment(params: any, loading: boolean) {
  return (
    <>
      {loading ? <CircularProgress color="inherit" size={18} /> : null}
      {params.InputProps.endAdornment}
    </>
  );
}
